import { environment } from '../../../environments/environment';
import { ImageMetadata } from '../metadata/image-metadata.model';

export class StoryImage {
  public id: string;
  public name: string;
  public createdAt: Date;
  public contentType: string;
  public imageUrl: string;
  public metadata: ImageMetadata;

  constructor(data: any = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
    this.createdAt = data?.createdAt ?? null;
    this.contentType = data?.contentType ?? '';
    this.imageUrl = `${environment.apiUrl}/api/image/${this.id}`;
    this.metadata = data?.metadata;
  }

  public updateUrl(): void {
    this.imageUrl = `${environment.apiUrl}/api/image/${this.id}`;
  }

  public static createFromApi(data: any = {}): StoryImage {
    const metadata = ImageMetadata.createFromApi({
      ...data?.meta ?? data?.metadata,
      index: data?.index ?? 0,
    });
    return new StoryImage({
      ...data,
      metadata,
    });
  }

  public processForApi(): Record<string, any> {
    return {
      id: this.id,
      meta: this.metadata.processForApi(),
    }
  }
}
